import { useLocation, useRouter } from "@tanstack/react-router";
import { observer } from "mobx-react-lite";
import { type FC, memo, useEffect, useState } from "react";
import AppState from "@/src/application/store/app-state";
import { useInject } from "@/src/presentation/hooks/useInject";

const NavigationLoading: FC = () => {
  return (
    <>
      <PathObserver />
      <LoadingOverlay />
    </>
  );
};

const LoadingOverlay = observer(() => {
  const appState = useInject(AppState);
  const [isNavigating, setIsNavigating] = useState(false);
  const router = useRouter();

  useEffect(() => {
    // Subscribe to navigation start
    const unsubBefore = router.subscribe("onBeforeNavigate", () => {
      setIsNavigating(true);
    });

    // Subscribe to navigation complete
    const unsubResolved = router.subscribe("onResolved", () => {
      setIsNavigating(false);
    });

    return () => {
      unsubBefore();
      unsubResolved();
    };
  }, [router]);

  const showLoading = appState.isLoading || isNavigating;

  if (!showLoading) {
    return null;
  }

  return (
    <div className="fixed inset-0 z-50 flex cursor-wait items-center justify-center bg-white/70">
      <div className="size-16 animate-spin rounded-full border-8 border-dashed border-brand-accent"></div>
    </div>
  );
});

const PathObserver: FC = memo(() => {
  const location = useLocation();
  const appState = useInject(AppState);

  useEffect(() => {
    appState?.setLoading(false);
  }, [location.pathname, appState]);

  return null;
});

export default NavigationLoading;
